<session-analytic-item-view
  (onExpanded)="onExpanded.emit($event)"
  [isExpanded]="isExpanded"
  [title]="'feedback-session-feedback-display_analytics_pauses-header' | translate"
  [helpDescription]="'session-analytics_pauses-help-description' | translate"
  [dataSummary]="'feedback-session-feedback-display_analytics_pauses_data-summary' | translate : {
        totalPauses,
        totalLengthyPauses
    }"
  [shouldTease]="shouldTease">
  <div graph
    class="pause-graph-container"
    role="application">
    @if (pauseInstances.length > 0) {
      <highcharts-chart
        [options]="chartOptions">
      </highcharts-chart>
    } @else {
      <analytic-graph-zero-state>
        {{(media.isYoutube() ? 'transcript-viewer-zero-state_youtube-subtext' : 'feedback-session-feedback-display_analytics_pauses_zero-state-label') | translate}}
      </analytic-graph-zero-state>
    }

  </div>
</session-analytic-item-view>
